//Highly recommend installing the i18n Ally VSCode extensions as it makes working with the translations so much easier. Name: i18n Ally - https://marketplace.visualstudio.com/items?itemName=Lokalise.i18n-ally
//Configuration help can be found at https://levelup.gitconnected.com/i18n-without-pain-using-this-vs-code-extension-a6eb10e53772

import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';

let i18n;

export const SUPPORT_LOCALES = ['en', 'fr', 'ur'];
const DEFAULT_LOCALE = 'en';

export function setI18nLanguage(locale) {
	loadLocaleMessages(locale);

	if (i18n.mode === 'legacy') {
		i18n.global.locale = locale;
	} else {
		i18n.global.locale.value = locale;
	}

	document.querySelector('html').setAttribute('lang', locale);
	localStorage.setItem('lang', locale);
}

export async function loadLocaleMessages(locale) {
	console.log('loading locale messages', locale);
	// load locale messages with dynamic import
	const messages = await import(/* webpackChunkName: "locale-[request]" */ `./locales/${locale}.json`);

	// set locale and locale message
	i18n.global.setLocaleMessage(locale, messages.default);

	return nextTick();
}

export default function setupI18n() {
	if (!i18n) {
		let locale = localStorage.getItem('lang') ?? DEFAULT_LOCALE;

		i18n = createI18n({
			globalInjection: true,
			legacy: false,
			locale: locale,
			fallbackLocale: DEFAULT_LOCALE,
		});

		setI18nLanguage(locale);
	}
	return i18n;
}
